( function() {
    "use strict";

    angular
        .module("ccsTrApp")
        .service("InvoiceCustomService", InvoiceCustomService);

    InvoiceCustomService.$inject = ['$http'];

    function InvoiceCustomService($http) {
        return {
            returnInvoiceByShipmentAndType: returnInvoiceByShipmentAndType,
            returnMinifiedInvoiceByShipmentAndType: returnMinifiedInvoiceByShipmentAndType,
            returnInvoicePricesByInvoice: returnInvoicePricesByInvoice,
            getMinifiedInvoicePricesByInvoice: getMinifiedInvoicePricesByInvoice,
            returnInvoicesGpfs: returnInvoicesGpfs,
            returnInvoicesGpfsDownload: returnInvoicesGpfsDownload,
            returnUsedShipments: returnUsedShipments,
            returnUsedShipmentStatuses: returnUsedShipmentStatuses,
            returnUsedShipmentLCs: returnUsedShipmentLCs,
            returnUsedShipmentBLs: returnUsedShipmentBLs,
            returnUsedContracts: returnUsedContracts,
            returnUsedContractStatuses: returnUsedContractStatuses,
            returnUsedContractTypes: returnUsedContractTypes,
            returnInvoiceAuditById: returnInvoiceAuditById,
            returnInvoicePrePayments: returnInvoicePrePayments,
            saveInvoicePrePayments: saveInvoicePrePayments,
            returnJapanInvoicesReport: returnJapanInvoicesReport,
            returnCategorizedInvoices: returnCategorizedInvoices,
            returnInvoicesForReport: returnInvoicesForReport,
            returnCategoryInvoiceItems: returnCategoryInvoiceItems,
            findAllInvoicesByShipmentIdForController: findAllInvoicesByShipmentIdForController
        };

        function saveInvoicePrePayments(id, list) {
            return $http({
                url: 'api/invoices/' + id + '/prepayments',
                method: 'POST',
                data: list,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function returnInvoicePrePayments(id) {
            var url = 'api/invoices/' + id + '/prepayments';
            return $http.get(url);
        }

        function returnInvoiceAuditById(id) {
            var url = "jv/audit/invoices/" + id;
            return $http.get(url);
        }

        function returnUsedContracts(type) {
            var url = "api/contracts/invoice/filter?type=" + type;
            return $http.get(url);
        }

        function returnUsedContractStatuses(type) {
            var url = "api/contracts/invoice/filter/statuses?type=" + type;
            return $http.get(url);
        }

        function returnUsedContractTypes(type) {
            var url = "api/contracts/invoice/filter/types?type=" + type;
            return $http.get(url);
        }

        function returnUsedShipments(type) {
            var url = "api/shipments/invoice/filter?type=" + type;
            return $http.get(url);
        }

        function returnUsedShipmentStatuses(type) {
            var url = "api/shipments/invoice/filter/statuses?type=" + type;
            return $http.get(url);
        }

        function returnUsedShipmentLCs(type) {
            var url = "api/shipments/invoice/filter/lcs?type=" + type;
            return $http.get(url);
        }

        function returnUsedShipmentBLs(type) {
            var url = "api/shipments/invoice/filter/bls?type=" + type;
            return $http.get(url);
        }

        function returnInvoiceByShipmentAndType( id, type ) {
            var url = "/api/invoices/shipment/" + id + "/type/" + type;
            return $http.get(url);
        }

        function returnMinifiedInvoiceByShipmentAndType(id, type) {
            var url = "/api/invoices/minified/shipment/" + id + "/type/" + type;
            return $http.get(url);
        }

        function returnInvoicePricesByInvoice(id, invType) {
            var url = "api/invoices/" + id + "/invoice-prices?invType=" + invType;
            return $http.get(url);
        }

        function getMinifiedInvoicePricesByInvoice(id, invType) {
            var url = "api/invoices/" + id + "/invoice-prices/minified?invType=" + invType;
            return $http.get(url);
        }

        function returnInvoicesGpfs() {
            var url = "api/invoices/gpfs";
            return $http.get(url);
        }

        function returnInvoicesGpfsDownload(type, ids) {
            var url = "api/invoices/gpfs/download-txt?gpfs-type=" + type + "&exclude-invoices=" + ids;
            return $http.get(url);
        }

        function returnJapanInvoicesReport( startDate, endDate ) {
            var url = "api/invoices/japan/report?startDate=" + startDate + "&endDate=" + endDate;
            return $http.get(url);
        }

        function returnCategorizedInvoices( startDate, endDate, invType, invStatus ) {
            var url = "api/invoices/categorized?startDate=" + startDate + "&endDate=" + endDate +
            "&purchase=" + invType.purchase + "&sale=" + invType.sale + "&japan=" + invType.japan +
            "&draft=" + invStatus.draft + "&approved=" + invStatus.approved + "&issued=" + invStatus.issued;
            return $http.get(url);
        }

        function returnInvoicesForReport( startDate, endDate, invType, invStatus, modDate ) {
            var url = "api/invoices/report?startDate=" + startDate + "&endDate=" + endDate + "&modDate=" + modDate +
                "&purchase=" + invType.purchase + "&sale=" + invType.sale + "&japan=" + invType.japan +
                "&draft=" + invStatus.draft + "&approved=" + invStatus.approved + "&issued=" + invStatus.issued;
            return $http.get(url);
        }

        function returnCategoryInvoiceItems(startDate, endDate, invType, invStatus, category) {
            var url = "api/invoices/categorized/items?startDate=" + startDate + "&endDate=" + endDate +
                "&purchase=" + invType.purchase + "&sale=" + invType.sale + "&japan=" + invType.japan +
                "&draft=" + invStatus.draft + "&approved=" + invStatus.approved + "&issued=" + invStatus.issued +
                "&category=" + category;
            return $http.get(url);
        }

        function findAllInvoicesByShipmentIdForController(shipmentId) {
            var url = "api/invoices/controller/shipment/" + shipmentId;
            return $http.get(url);
        }
    }
})();
